var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"container-fluid p-0"},[_c('div',{staticClass:"comingsoon"},[_c('div',{staticClass:"comingsoon-inner text-center"},[_c('img',{attrs:{"src":require("@/assets/TAJimages/logo/login.png"),"width":"400","alt":""}}),_c('h5',[_vm._v("WE ARE COMING SOON")])])])])])])
}]

export { render, staticRenderFns }